import { render } from "./TotalUserCard.vue?vue&type=template&id=314d5f75"
import script from "./TotalUserCard.vue?vue&type=script&lang=js"
export * from "./TotalUserCard.vue?vue&type=script&lang=js"

import "./TotalUserCard.vue?vue&type=style&index=0&id=314d5f75&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__